import isFilterEntitysId from './is-filter-entitys-id';
import getFilterProps from './get-filter-props';
import { ID } from '../constants';
const getQueryProps = (inheritedFilters, currentSchema, filterEntitySchema = {}) => {
  if (!currentSchema || !inheritedFilters.length) return ID;
  const {
    identifier: currentEntityId,
    properties
  } = currentSchema;
  const {
    identifier: filterEntityId
  } = filterEntitySchema;
  return inheritedFilters.reduce((acc, filter) => {
    const {
      filterName,
      relationName,
      relationProp,
      relationEntityName,
      isEntityItself,
      relationForeignKeys,
      shouldIgnoreFilter
    } = getFilterProps(filter, currentSchema, filterEntitySchema);
    if (shouldIgnoreFilter) return acc;
    if (relationForeignKeys && relationForeignKeys.length) {
      return `${acc} ${relationForeignKeys.join(' ')}`;
    }
    if (filterName === ID) {
      const queryValue = Object.keys(properties).find(propKey => properties[propKey] && properties[propKey].relation && properties[propKey].relation.entityIdentifier === filterEntityId);
      if (queryValue) return `${acc} ${queryValue} `;
    }
    const queryProp = relationEntityName ? `${relationName} { ${relationProp} }` : filterName;
    const queryPropFinalValue = isEntityItself && isFilterEntitysId(filterName, currentEntityId) ? ID : queryProp;
    return `${acc} ${queryPropFinalValue} `;
  }, ID);
};
export default getQueryProps;
//# sourceMappingURL=get-query-props.js.map